export const SYLLABLE_TYPES = {
  VCe: "VC-e",
  VT: "VT",
  rControlled: "R-Controlled",
  VCCV: "VC/CV",
  compound: "Compound",
  CLe: "C-le",
  VV: "V/V",
  vCV: "V/CV",
  VCv: "VC/V",
};

export const SYLLABLE_TYPES_PRIORITY = [
  SYLLABLE_TYPES.compound,
  SYLLABLE_TYPES.VT,
  SYLLABLE_TYPES.VCe,
  SYLLABLE_TYPES.rControlled,
  SYLLABLE_TYPES.CLe,
  SYLLABLE_TYPES.VCCV,
  SYLLABLE_TYPES.vCV,
  SYLLABLE_TYPES.VCv,
];

export function getFTUEData(locale = "en-us", tutorInSpanish = false, type) {
  const isEnglish = locale.toLowerCase() === "en-us" && !tutorInSpanish;
  switch (type) {
    case SYLLABLE_TYPES.VCe:
      return isEnglish
        ? {
            headline: "Silent e: reptile",
            intro_resume:
              "You can use your knowledge of syllable types to help you divide words. When a word has an e that is silent, keep the e together with the closest vowel, like in the word reptile.",
            word: () => [
              { id: "r111", content: "r", rule: "" },
              { id: "e222", content: "e", rule: "v" },
              { id: "p333", content: "p", rule: "" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "t666", content: "t", rule: "c" },
              { id: "i666", content: "i", rule: "v" },
              { id: "l666", content: "l", rule: "c" },
              { id: "e777", content: "e", rule: "v" },
            ],
            watchWord: "cos/tume",
            response_wrong: ({ word }) =>
              `This word can be divided using your knowledge of the silent e syllable type. This word is ${word}. Let’s get back to the story.`,
          }
        : {
            headline: "Silent e: reptile",
            intro_resume:
              "You can use your knowledge of syllable types to help you divide words. When a word has an e that is silent, keep the e together with the closest vowel, like in the word reptile.",
            word: () => [
              { id: "r111", content: "r", rule: "" },
              { id: "e222", content: "e", rule: "v" },
              { id: "p333", content: "p", rule: "" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "t666", content: "t", rule: "c" },
              { id: "i666", content: "i", rule: "v" },
              { id: "l666", content: "l", rule: "c" },
              { id: "e777", content: "e", rule: "v" },
            ],
            watchWord: "cos/tume",
            response_wrong: ({ word }) =>
              `This word can be divided using your knowledge of the silent e syllable type. This word is ${word}. Let’s get back to the story.`,
          };
    case SYLLABLE_TYPES.rControlled:
      return isEnglish
        ? {
            headline: "R-Controlled Vowels: tiger",
            intro_resume:
              "When a word has a vowel followed by the letter “r,” keep the vowel and the “r” together. Then look at the consonants between the vowels to decide where to divide the word. ",
            word: () => [
              { id: "t111", content: "t", rule: "" },
              { id: "i222", content: "i", rule: "v" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "g333", content: "g", rule: "c" },
              { id: "e666", content: "e", rule: "v" },
              { id: "r666", content: "r", rule: "" },
            ],
            watchWord: "sis/ter",
            response_wrong: ({ word }) =>
              `This word can be divided using your knowledge of r-controlled vowels. This word is ${word}. Let’s get back to the story.`,
          }
        : {
            headline: "R-Controlled Vowels: tiger",
            intro_resume:
              "When a word has a vowel followed by the letter “r,” keep the vowel and the “r” together. Then look at the consonants between the vowels to decide where to divide the word. ",
            word: () => [
              { id: "t111", content: "t", rule: "" },
              { id: "i222", content: "i", rule: "v" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "g333", content: "g", rule: "c" },
              { id: "e666", content: "e", rule: "v" },
              { id: "r666", content: "r", rule: "" },
            ],
            watchWord: "sis/ter",
            response_wrong: ({ word }) =>
              `This word can be divided using your knowledge of r-controlled vowels. This word is ${word}. Let’s get back to the story.`,
          };
    case SYLLABLE_TYPES.VCCV:
      return isEnglish
        ? {
            headline: "VC/CV: magnet",
            intro_resume:
              "When two vowels are separated by two consonants, you usually split the word between the two consonants, like in the word magnet.",
            word: () => [
              { id: "m111", content: "m", rule: "" },
              { id: "a222", content: "a", rule: "v" },
              { id: "g333", content: "g", rule: "c" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "n444", content: "n", rule: "c" },
              { id: "e555", content: "e", rule: "v" },
              { id: "t666", content: "t", rule: "" },
            ],
            watchWord: "rab/bit",
            response_wrong: ({ word }) =>
              `You divided between two consonants, creating two closed syllables. This word is ${word}. Let’s get back to the story.`,
          }
        : {
            headline: "VC/CV: magnet",
            intro_resume:
              "When two vowels are separated by two consonants, you usually split the word between the two consonants, like in the word magnet.",
            word: () => [
              { id: "m111", content: "m", rule: "" },
              { id: "a222", content: "a", rule: "v" },
              { id: "g333", content: "g", rule: "c" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "n444", content: "n", rule: "c" },
              { id: "e555", content: "e", rule: "v" },
              { id: "t666", content: "t", rule: "" },
            ],
            watchWord: "rab/bit",
            response_wrong: ({ word }) =>
              `You divided between two consonants, creating two closed syllables. This word is ${word}. Let’s get back to the story.`,
          };
    case SYLLABLE_TYPES.compound:
      return isEnglish
        ? {
            headline: "Compound Words: football",
            intro_resume:
              "Compound words are two smaller words put together to make a bigger word. Look for the smaller words and divide between them, like in the word football.",
            word: () => [
              { id: "f111", content: "f", rule: "" },
              { id: "o222", content: "o", rule: "" },
              { id: "o333", content: "o", rule: "" },
              { id: "t666", content: "t", rule: "" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "b666", content: "b", rule: "" },
              { id: "a666", content: "a", rule: "" },
              { id: "l666", content: "l", rule: "" },
              { id: "l777", content: "l", rule: "" },
            ],
            watchWord: "out/side",
            response_wrong: ({ word }) =>
              `This word can be divided using your knowledge of compound words.. This word is ${word}. Let’s get back to the story.`,
          }
        : {
            headline: "Compound Words: football",
            intro_resume:
              "Compound words are two smaller words put together to make a bigger word. Look for the smaller words and divide between them, like in the word football.",
            word: () => [
              { id: "f111", content: "f", rule: "" },
              { id: "o222", content: "o", rule: "" },
              { id: "o333", content: "o", rule: "" },
              { id: "t666", content: "t", rule: "" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "b666", content: "b", rule: "" },
              { id: "a666", content: "a", rule: "" },
              { id: "l666", content: "l", rule: "" },
              { id: "l777", content: "l", rule: "" },
            ],
            watchWord: "out/side",
            response_wrong: ({ word }) =>
              `This word can be divided using your knowledge of compound words.. This word is ${word}. Let’s get back to the story.`,
          };
    case SYLLABLE_TYPES.CLe:
      return isEnglish
        ? {
            headline: "Consonant + le: turtle",
            intro_resume:
              "When a word has a consonant + l e, keep the consonant + l e together and divide before it, like in the word turtle.",
            word: () => [
              { id: "d111", content: "t", rule: "" },
              { id: "u222", content: "u", rule: "" },
              { id: "e333", content: "r", rule: "" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "t666", content: "t", rule: "c" },
              { id: "l34666", content: "l", rule: "" },
              { id: "e3666", content: "e", rule: "v" },
            ],
            watchWord: "bub/ble",
            response_wrong: ({ word }) =>
              `This word can be divided using your knowledge of the consonant + l e syllable type. This word is ${word}. Let’s get back to the story.`,
          }
        : {
            headline: "Consonant + le: turtle",
            intro_resume:
              "When a word has a consonant + l e, keep the consonant + l e together and divide before it, like in the word turtle.",
            word: () => [
              { id: "d111", content: "t", rule: "" },
              { id: "u222", content: "u", rule: "" },
              { id: "e333", content: "r", rule: "" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "t666", content: "t", rule: "c" },
              { id: "l34666", content: "l", rule: "" },
              { id: "e3666", content: "e", rule: "v" },
            ],
            watchWord: "bub/ble",
            response_wrong: ({ word }) =>
              `This word can be divided using your knowledge of the consonant + l e syllable type. This word is ${word}. Let’s get back to the story.`,
          };
    case SYLLABLE_TYPES.VV:
      return isEnglish
        ? {
            headline: "V/V: lion",
            intro_resume:
              "If two vowels are next to each other, but they are not a vowel team, divide between them, like in the word lion.",
            word: () => [
              { id: "d111", content: "l", rule: "" },
              { id: "u222", content: "i", rule: "v" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "e333", content: "o", rule: "v" },
              { id: "t666", content: "n", rule: "" },
            ],
            watchWord: "po/et",
            response_wrong: ({ word }) =>
              `This word can be divided using the VV pattern. This word is ${word}. Let’s get back to the story.`,
          }
        : {
            headline: "V/V: lion",
            intro_resume:
              "If two vowels are next to each other, but they are not a vowel team, divide between them, like in the word lion.",
            word: () => [
              { id: "d111", content: "l", rule: "" },
              { id: "u222", content: "i", rule: "v" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "e333", content: "o", rule: "v" },
              { id: "t666", content: "n", rule: "" },
            ],
            watchWord: "po/et",
            response_wrong: ({ word }) =>
              `This word can be divided using the VV pattern. This word is ${word}. Let’s get back to the story.`,
          };
    case SYLLABLE_TYPES.vCV:
      return isEnglish
        ? {
            headline: "V/CV: robot",
            intro_resume:
              "When a word has the VCV pattern, one of the most common ways you can divide is before the consonant. This makes the first syllable open and the first vowel long, like in the word robot.",
            word: () => [
              { id: "r111", content: "r", rule: "" },
              { id: "o222", content: "o", rule: "v" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "b333", content: "b", rule: "c" },
              { id: "o444", content: "o", rule: "v" },
              { id: "t666", content: "t", rule: "" },
            ],
            watchWord: "ba/by",
            response_wrong: ({ word }) =>
              `This word can be divided using the VCV pattern. This word is ${word}. Let’s get back to the story.`,
          }
        : {
            headline: "V/CV: robot",
            intro_resume:
              "When a word has the VCV pattern, one of the most common ways you can divide is before the consonant. This makes the first syllable open and the first vowel long, like in the word robot.",
            word: () => [
              { id: "r111", content: "r", rule: "" },
              { id: "o222", content: "o", rule: "v" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "b333", content: "b", rule: "c" },
              { id: "o444", content: "o", rule: "v" },
              { id: "t666", content: "t", rule: "" },
            ],
            watchWord: "ba/by",
            response_wrong: ({ word }) =>
              `This word can be divided using the VCV pattern. This word is ${word}. Let’s get back to the story.`,
          };
    case SYLLABLE_TYPES.VCv:
      return isEnglish
        ? {
            headline: "VC/V: magic",
            intro_resume:
              "When a word has the VCV pattern, one of the ways you can split the word is after the consonant. This makes the first syllable closed and the first vowel short, like in the word magic.",
            word: () => [
              { id: "m111", content: "m", rule: "" },
              { id: "a222", content: "a", rule: "v" },
              { id: "g333", content: "g", rule: "c" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "i444", content: "i", rule: "v" },
              { id: "c666", content: "c", rule: "" },
            ],
            watchWord: "hab/it",
            response_wrong: ({ word }) =>
              `This word can be divided using the VCV pattern. This word is ${word}. Let’s get back to the story.`,
          }
        : {
            headline: "VC/V: magic",
            intro_resume:
              "When a word has the VCV pattern, one of the ways you can split the word is after the consonant. This makes the first syllable closed and the first vowel short, like in the word magic.",
            word: () => [
              { id: "m111", content: "m", rule: "" },
              { id: "a222", content: "a", rule: "v" },
              { id: "g333", content: "g", rule: "c" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "i444", content: "i", rule: "v" },
              { id: "c666", content: "c", rule: "" },
            ],
            watchWord: "hab/it",
            response_wrong: ({ word }) =>
              `This word can be divided using the VCV pattern. This word is ${word}. Let’s get back to the story.`,
          };
    case SYLLABLE_TYPES.VT:
      return isEnglish
        ? {
            headline: "Vowel Teams: toucan",
            intro_resume:
              "You can use your knowledge of syllable types to help you divide words. Keep vowel teams together in one syllable. If there are consonants between the vowel team and other vowels, you usually divide in front of the consonant, like in the word toucan.",
            word: () => [
              { id: "t111", content: "t", rule: "" },
              { id: "o222", content: "ou", rule: "v" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "c444", content: "c", rule: "c" },
              { id: "a666", content: "a", rule: "v" },
              { id: "n666", content: "n", rule: "" },
            ],
            watchWord: "cray/on",
            response_wrong: ({ word }) =>
              `This word can be divided using your knowledge of vowel teams. This word is ${word}. Let’s get back to the story.`,
          }
        : {
            headline: "Vowel Teams: toucan",
            intro_resume:
              "You can use your knowledge of syllable types to help you divide words. Keep vowel teams together in one syllable. If there are consonants between the vowel team and other vowels, you usually divide in front of the consonant, like in the word toucan.",
            word: () => [
              { id: "t111", content: "t", rule: "" },
              { id: "o222", content: "ou", rule: "v" },
              { id: "divider123", content: "/", rule: "divider" },
              { id: "c444", content: "c", rule: "c" },
              { id: "a666", content: "a", rule: "v" },
              { id: "n666", content: "n", rule: "" },
            ],
            watchWord: "cray/on",
            response_wrong: ({ word }) =>
              `This word can be divided using your knowledge of vowel teams. This word is ${word}. Let’s get back to the story.`,
          };
  }
}
